export default __webpack_public_path__ + "static/media/04.aa9354e9.jpg";